import { IconButton } from '../primitives/icon-button.js'
import type { IconButtonProps } from '../primitives/icon-button.js'
import { Close as CloseIcon } from '@tunasong/icons'
import type { MouseEvent } from 'react'
import styles from './close-button.module.css'

export interface CloseButtonProps extends IconButtonProps {
  onClose: (ev: MouseEvent) => void
}

export const CloseButton = ({ onClose, ...restProps }: CloseButtonProps) => {
  if (!onClose) {
    return null
  }

  return (
    <IconButton
      {...restProps}
      className={styles.closeButton}
      aria-label="Close"
      tabIndex={-1}
      onClick={onClose}
    >
      <CloseIcon />
    </IconButton>
  )
}

export default CloseButton
